{
  "title": "Cuenta",
  "description": "Gestiona tu perfil e identidad en la plataforma.",
  "profileTitle": "Perfil",
  "profileDescription": "Tu nombre y correo. Guardar un nombre se aplica de inmediato; un cambio de correo se confirma con un enlace que enviamos a la nueva dirección.",
  "firstNameLabel": "Nombre",
  "lastNameLabel": "Apellidos",
  "emailLabel": "Correo electrónico",
  "emailHint": "Se usa para iniciar sesión y para las notificaciones de la cuenta.",
  "save": "Guardar cambios",
  "sendVerification": "Enviar enlace de verificación",
  "saved": "Guardado",
  "savedDescription": "Tu perfil se ha actualizado.",
  "saveError": "No pudimos guardar tus cambios.",
  "saveErrorDescription": "Inténtalo de nuevo y, si sigue ocurriendo, contacta con soporte.",
  "emailSent": "Revisa tu bandeja de entrada",
  "emailSentDescription": "Enviamos un enlace a {{email}} para confirmar el cambio.",
  "emailError": "No pudimos iniciar el cambio de correo.",
  "emailUnchanged": "Ese ya es tu correo electrónico.",
  "identityTitle": "Identidad",
  "identityDescription": "Tu estado y tus roles en esta cuenta.",
  "statusLabel": "Estado de la cuenta",
  "rolesLabel": "Roles",
  "tenantLabel": "Organización",
  "platformTenant": "Plataforma",
  "validation": {
    "firstNameRequired": "Introduce tu nombre.",
    "lastNameRequired": "Introduce tus apellidos.",
    "nameTooLong": "Usa 100 caracteres o menos.",
    "emailRequired": "Introduce un correo electrónico.",
    "emailInvalid": "Introduce un correo electrónico válido."
  }
}
